import React, { ReactElement } from "react";
import { FormattedMessage } from "react-intl";

import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import IconSelector from "components/shared/images/IconSelector";

const SpecificWebAppRecap = ({
 server,
 site,
 type,
 version,
 system,
 appType,
 enviroment_version
}: {
 server: string;
 site: string;
 type: string;
 version: string;
 system: string;
 appType: string;
 enviroment_version: string;
}): ReactElement => {
 const RenderAppIcon = (): ReactElement => {
  switch (appType) {
   case "react":
    return <IconSelector icon="ReactIcon" />;
   case "vue":
    return <IconSelector icon="VueIcon" />;
   default:
    return <></>;
  }
 };

 const RenderTypeIcon = ({ version }: { version: string }): ReactElement => {
  if (version.includes("php")) {
   return <IconSelector icon={"PhpIcon"} props={{ fontSize: "large" }} />;
  } else if (version.includes("tomcat")) {
   return <IconSelector icon={"TomcatIcon"} props={{ fontSize: "large" }} />;
  } else if (version.includes("odoo")) {
   return <IconSelector icon={"OdooIcon"} props={{ fontSize: "large" }} />;
  } else if (version.includes("nodejs")) {
   return <IconSelector icon={"NodejsIcon"} />;
  } else if (version.includes("nextjs")) {
   return <IconSelector icon={"NextjsIcon"} />;
  } else if (version.includes("litespeed")) {
   return (
    <img
     width={20}
     height={20}
     src={`${process.env.PUBLIC_URL}/svg/providers/litespeed.svg`}
     alt="litespeed"
    />
   );
  } else if (version.includes("apache")) {
   return (
    <img
     width={20}
     height={20}
     src={`${process.env.PUBLIC_URL}/svg/providers/apache2.svg`}
     alt="apache"
    />
   );
  } else if (version.includes("nginx")) {
   return (
    <img
     width={20}
     height={20}
     src={`${process.env.PUBLIC_URL}/svg/providers/nginx.svg`}
     alt="nginx"
    />
   );
  } else {
   return <></>;
  }
 };

 return (
  <Paper
   elevation={1}
   sx={{
    p: 2,
    maxHeight: 580,
    position: "sticky",
    borderRadius: "5px"
   }}>
   <Stack mb={2} alignItems="center" direction="row" spacing={1}>
    <RenderAppIcon />
    <Typography variant="unboundedTitle" fontWeight="bold" fontSize={18}>
     <FormattedMessage id="docker.website.add.recap" />
    </Typography>
   </Stack>
   <Divider sx={{ my: 1 }} />
   <Stack textAlign="left" mb={1}>
    <Typography variant="unboundedTitle" fontSize={14}>
     <FormattedMessage id="docker.website.add.serverData" />
    </Typography>
   </Stack>
   <Stack direction="row" spacing={2}>
    <Typography variant="subtitle2" minWidth={160} textAlign="start" fontWeight="bold">
     <FormattedMessage id="docker.website.add.serverName" />:
    </Typography>
    <Typography variant="subtitle2" noWrap>
     {server}
    </Typography>
   </Stack>
   <Stack direction="row" spacing={2}>
    <Typography variant="subtitle2" minWidth={160} textAlign="start" fontWeight="bold">
     <FormattedMessage id="docker.website.add.systemType" />:
    </Typography>
    <Stack direction="row" spacing={1} alignItems="center">
     <RenderTypeIcon version={system} />
     <Typography variant="subtitle2" noWrap>
      {system}
     </Typography>
    </Stack>
   </Stack>
   <Stack direction="row" spacing={2}>
    <Typography variant="subtitle2" minWidth={160} textAlign="start" fontWeight="bold">
     <FormattedMessage id="docker.website.add.enviromentVersion" />:
    </Typography>
    <Typography variant="subtitle2" noWrap>
     {enviroment_version}
    </Typography>
   </Stack>
   <Divider sx={{ my: 1 }} />
   <Stack textAlign="left" mb={1}>
    <Typography variant="unboundedTitle" fontSize={14}>
     <FormattedMessage id="docker.website.add.siteData" />
    </Typography>
   </Stack>
   <Stack direction="row" spacing={2}>
    <Typography variant="subtitle2" minWidth={160} textAlign="start" fontWeight="bold">
     <FormattedMessage id="docker.website.add.siteName" />:
    </Typography>
    <Typography variant="subtitle2" noWrap>
     {site}
    </Typography>
   </Stack>
   <Stack direction="row" spacing={2}>
    <Typography variant="subtitle2" minWidth={160} textAlign="start" fontWeight="bold">
     <FormattedMessage id="docker.website.add.type" />:
    </Typography>
    <Stack direction="row" spacing={1} alignItems="center">
     <RenderTypeIcon version={type} />
     <Typography variant="subtitle2" noWrap>
      {type}
     </Typography>{" "}
    </Stack>
   </Stack>
   <Stack direction="row" spacing={2}>
    <Typography variant="subtitle2" minWidth={160} textAlign="start" fontWeight="bold">
     <FormattedMessage id="docker.website.add.version" />:
    </Typography>
    <Typography variant="subtitle2" noWrap>
     {version}
    </Typography>
   </Stack>
   <Stack direction="row" spacing={2}>
    <Typography variant="subtitle2" minWidth={160} textAlign="start" fontWeight="bold">
     <FormattedMessage id="docker.website.add.library" />:
    </Typography>
    <Stack direction="row" spacing={1}>
     <RenderAppIcon />
     <Typography variant="subtitle2" noWrap>
      {appType}
     </Typography>
    </Stack>
   </Stack>
  </Paper>
 );
};

export default SpecificWebAppRecap;
